const config = {
  network: "Polygon Network",
  MAX_GAS_LIMIT: 800000,
  thegraph:
    "https://api.thegraph.com/subgraphs/name/stablecoinfactory/scf-graph",
  tokens: {
    USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    USDC: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    SCF: "0x7075f7B8D36998c4429Fc43d20ce41f2a3C7EF9a",
    aUSDT: "0x60D55F02A771d515e077c9C2403a1ef324885CeC",
    aUSDC: "0x1a13F4Ca1d028320A707D99520AbFefca3998b7F",
  },
  controller: "0xF80a7ec392563A141BECfa6Ea108c3fE79619271",
};

export default config;
